module.exports = __webpack_public_path__ + "img/plugin_rerun_setup.png";